import { render, staticRenderFns } from "./InventoryEditModal.vue?vue&type=template&id=45674cdc"
import script from "./InventoryEditModal.vue?vue&type=script&lang=ts"
export * from "./InventoryEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports